import { faUnlock, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../constants';
import { useAuth } from '../hooks/AuthProvider';
import { Loader, toast } from '../utils/utils';

const Login = () => {
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const [invalidLoginMessage, setInvalidLoginMessage] = useState({
    title: 'Please try again..',
    message: ' You have entered incorrect username or password.',
  });

  const { t, i18n } = useTranslation();
  useEffect(() => {
    const lang = window.localStorage.getItem('lang')
      ? window.localStorage.getItem('lang')
      : 'ar';
    if (lang === 'en') {
      i18n.changeLanguage('en');
      window.localStorage.setItem('lang', 'en');
      document.body.dir = 'ltr';
    } else {
      i18n.changeLanguage('ar');
      window.localStorage.setItem('lang', 'ar');
      document.body.dir = 'rtl';
      
    }
  }, [i18n]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const loginData = {
      UserName: data.email,
      Password: data.password,
      ApplicationId: CONSTANTS.APP_ID,
    };
    setInvalidLogin(false);
    setLoading(true);
    fetch(CONSTANTS.Login, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(loginData),
    })
      .then((res) => res.json())
      .then((json) => {
        setLoading(false);
        if (json.IsAuthorized && json.IsValidUser) {
          console.log(json);
          json.UserSettings.forEach((userSetting)=>{
            if(userSetting.Name === 'EJE.Token'){
          
              auth.loginAction(userSetting.Value,userSetting);
              window.localStorage.setItem('access_token',userSetting.Value);
              localStorage.setItem('lastCleared', Date.now().toString());
            }
          })
          
        } else if (!json.IsAuthorized && json.IsValidUser) {
          setInvalidLoginMessage({
            title: 'Not Authorized',
            message:
              'Your not authorized to use this app. Kindly contact the admin',
          });
          setInvalidLogin(true);
        } else {
          setInvalidLoginMessage({
            title: 'Please try again..',
            message: ' You have entered incorrect username or password.',
          });
          setInvalidLogin(true);
        }
      })
      .catch((e) => {
        setInvalidLogin(true);
        setLoading(false);
        toast(
          'Error',
          'Failed to fetch the data. Please try again',
          'Ok',
          'error'
        );
      });
  };

 
  return (
    <main
      className={`flex   login-panel h-full min-h-screen items-center  w-full flex-row justify-center `}>
      <div className='min-w-[30%]'>
        <div className=' bg-white gap-5 rounded-lg   px-10 py-10  flex-col flex  overflow-y-scroll no-scrollbar'>
          <div className='gap-10 flex-row flex p-13 items-center justify-center'>
            <img
              src='../assets/img/eje-logo.svg'
              alt='gargash'
               
              priority
            />
          </div>

          <div className='gap-10 flex  flex-col'>
            <div>
              <h1 className='text-xl text-center font-thin text-gray-400 '>
                {t('WelcomeBack')}
              </h1>
              <p className='text-2xl text-center text-black'>
                {t('Logintoviewandmanagejob')}
              </p>
            </div>

            {invalidLogin && (
              <div
                className='flex border-1 flex-row rounded p-6 items-center gap-8'
                style={{
                  backgroundColor: '#F7F7F7',
                  border: '1px solid red',
                }}>
                <div
                  style={{
                    backgroundColor: 'fill: rgba(217, 217, 217, 0.25)',
                  }}
                  className='rounded'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='45'
                    height='45'
                    viewBox='0 0 40 40'
                    fill='none'>
                    <g clipPath='url(#clip0_538_3074)'>
                      <path
                        d='M39.661 28.7951V34.8232C39.661 36.1456 38.5892 37.2175 37.2667 37.2175H2.3943C1.07185 37.2176 0 36.1457 0 34.8233V28.7952C0 27.4727 1.07185 26.4009 2.3943 26.4009H37.2667C38.5892 26.4008 39.661 27.4727 39.661 28.7951Z'
                        fill='#B68A35'
                      />
                      <path
                        d='M12.9437 37.2176H2.3943C1.07185 37.2176 0 36.1457 0 34.8233V28.7952C0 27.4727 1.07185 26.4009 2.3943 26.4009H11.8742C10.7372 29.448 10.1666 33.6457 12.9437 37.2176Z'
                        fill='#B68A35'
                      />
                      <path
                        d='M30.3461 22.7956H9.31443C7.39575 22.7956 6.25612 20.6511 7.33029 19.0605L16.8932 4.90769L17.8462 3.49747C18.796 2.09199 20.8646 2.09199 21.8144 3.49747L32.3302 19.0605C33.4044 20.6511 32.2648 22.7956 30.3461 22.7956Z'
                        fill='#B68A35'
                      />
                      <path
                        d='M19.7569 18.9733C20.2644 18.9733 20.6759 18.5618 20.6759 18.0543C20.6759 17.5467 20.2644 17.1353 19.7569 17.1353C19.2493 17.1353 18.8379 17.5467 18.8379 18.0543C18.8379 18.5618 19.2493 18.9733 19.7569 18.9733Z'
                        fill='white'
                      />
                      <path
                        d='M19.7537 15.2964C19.2287 15.2964 18.7858 14.9055 18.7207 14.3845L18.1436 9.76819C18.0226 8.79972 18.7777 7.94434 19.7537 7.94434C20.7297 7.94434 21.4848 8.79972 21.3638 9.76819L20.7867 14.3845C20.7216 14.9055 20.2788 15.2964 19.7537 15.2964Z'
                        fill='white'
                      />
                      <path
                        d='M18.0148 30.0407C17.8707 29.7706 17.5511 29.6775 17.3008 29.8329L15.8346 30.7426V28.8859C15.8346 28.5743 15.6006 28.3218 15.3118 28.3218C15.023 28.3218 14.7889 28.5744 14.7889 28.8859V30.7426L13.3228 29.8329C13.0723 29.6775 12.7528 29.7706 12.6088 30.0407C12.4648 30.3108 12.551 30.6558 12.8013 30.811L14.2629 31.718L12.8013 32.625C12.551 32.7803 12.4648 33.1252 12.6088 33.3953C12.7055 33.5767 12.8815 33.6783 13.0625 33.6783C13.151 33.6783 13.2406 33.6541 13.3228 33.6031L14.7889 32.6934V34.5501C14.7889 34.8617 15.023 35.1142 15.3118 35.1142C15.6006 35.1142 15.8346 34.8616 15.8346 34.5501V32.6934L17.3008 33.6031C17.3829 33.6541 17.4726 33.6783 17.561 33.6783C17.742 33.6783 17.918 33.5767 18.0148 33.3953C18.1587 33.1252 18.0725 32.7803 17.8222 32.625L16.3607 31.718L17.8222 30.811C18.0725 30.6558 18.1587 30.3108 18.0148 30.0407Z'
                        fill='white'
                      />
                      <path
                        d='M26.4113 30.0407C26.2672 29.7706 25.9476 29.6775 25.6973 29.8329L24.2311 30.7426V28.8859C24.2311 28.5743 23.9971 28.3218 23.7083 28.3218C23.4195 28.3218 23.1854 28.5744 23.1854 28.8859V30.7426L21.7193 29.8329C21.4688 29.6775 21.1492 29.7706 21.0052 30.0407C20.8613 30.3108 20.9475 30.6558 21.1978 30.811L22.6594 31.718L21.1978 32.625C20.9475 32.7803 20.8613 33.1252 21.0052 33.3953C21.102 33.5767 21.278 33.6783 21.459 33.6783C21.5475 33.6783 21.637 33.6541 21.7193 33.6031L23.1854 32.6934V34.5501C23.1854 34.8617 23.4195 35.1142 23.7083 35.1142C23.9971 35.1142 24.2311 34.8616 24.2311 34.5501V32.6934L25.6973 33.6031C25.7794 33.6541 25.8691 33.6783 25.9575 33.6783C26.1385 33.6783 26.3145 33.5767 26.4113 33.3953C26.5552 33.1252 26.469 32.7803 26.2187 32.625L24.7572 31.718L26.2187 30.811C26.469 30.6558 26.5552 30.3108 26.4113 30.0407Z'
                        fill='white'
                      />
                      <path
                        d='M34.6211 32.625L33.1596 31.718L34.6211 30.811C34.8715 30.6557 34.9576 30.3108 34.8137 30.0407C34.6696 29.7705 34.35 29.6775 34.0997 29.8329L32.6335 30.7426V28.8859C32.6335 28.5743 32.3995 28.3218 32.1107 28.3218C31.8219 28.3218 31.5878 28.5744 31.5878 28.8859V30.7426L30.1216 29.8328C29.8712 29.6775 29.5516 29.7706 29.4076 30.0406C29.2637 30.3107 29.3499 30.6556 29.6002 30.811L31.0617 31.7179L29.6002 32.6249C29.3498 32.7803 29.2637 33.1251 29.4076 33.3952C29.5043 33.5767 29.6803 33.6783 29.8614 33.6783C29.9498 33.6783 30.0394 33.6541 30.1216 33.6031L31.5878 32.6933V34.55C31.5878 34.8616 31.8219 35.1142 32.1107 35.1142C32.3995 35.1142 32.6335 34.8615 32.6335 34.55V32.6933L34.0997 33.603C34.1818 33.654 34.2715 33.6782 34.3599 33.6782C34.5409 33.6782 34.7169 33.5767 34.8137 33.3952C34.9577 33.1252 34.8715 32.7803 34.6211 32.625Z'
                        fill='white'
                      />
                      <path
                        d='M10.1361 30.0406C9.98915 29.7704 9.66287 29.6774 9.40731 29.8328L7.91073 30.7426V28.8859C7.91073 28.5743 7.67182 28.3218 7.37704 28.3218C7.08225 28.3218 6.84334 28.5744 6.84334 28.8859V30.7426L5.34683 29.8329C5.0912 29.6775 4.76506 29.7706 4.61801 30.0407C4.4711 30.3107 4.5591 30.6557 4.81458 30.811L6.3064 31.718L4.81458 32.6249C4.55903 32.7803 4.4711 33.1251 4.61801 33.3953C4.71678 33.5768 4.89643 33.6783 5.08119 33.6783C5.17146 33.6783 5.26291 33.6541 5.34683 33.6031L6.84334 32.6934V34.5501C6.84334 34.8617 7.08225 35.1142 7.37704 35.1142C7.67182 35.1142 7.91073 34.8616 7.91073 34.5501V32.6934L9.40731 33.6032C9.49116 33.6542 9.58268 33.6784 9.67295 33.6784C9.85771 33.6784 10.0374 33.5768 10.1361 33.3953C10.283 33.1253 10.195 32.7804 9.93956 32.625L8.44774 31.718L9.93956 30.8111C10.195 30.6556 10.283 30.3107 10.1361 30.0406Z'
                        fill='white'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_538_3074'>
                        <rect width='39.661' height='39.661' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className='flex flex-col justify-between gap-2'>
                  <span className='font-bold text-md text-black'>
                    {invalidLoginMessage.title}
                  </span>
                  <span className='text-sm text-black'>
                    {invalidLoginMessage.message}
                  </span>
                </div>
              </div>
            )}

            <form
              onSubmit={handleSubmit(onSubmit)}
              className='flex flex-col justify-between gap-5'>
              <div>
                <label
                  htmlFor='email'
                  className='block mb-2 text-sm font-medium text-gray-900 '>
                  {t('Email')}
                </label>
                <div>
                  <div className='flex'>
                    <span className='inline-flex items-center px-4 text-sm text-gray-900 bg-white border border-e-0 border-gray-300 rounded-s-md'>
                      <FontAwesomeIcon icon={faUser} color='#B68A35' />
                    </span>
                    <input
                      {...register('email', {
                        required: true,
                        // validate: {
                        //   matchPattern: (v) =>
                        //     /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                        //       v
                        //     ) || 'Email address must be a valid address',
                        // },
                      })}
                      type='text'
                      id='email'
                      name='email'
                      autoComplete='off'
                      className='rounded-none rounded-e-lg bg-white border border-s-0 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  '
                      placeholder={t('EnteryouremailID')}
                    />
                  </div>
                  {errors.email && (
                    <p
                      id='password_error'
                      className='mt-2 text-xs text-red-600 
                      '>
                      {t('usernameRequired')}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor='input-group-1'
                  className='block mb-2 text-sm font-medium text-gray-900 
                  '>
                  {t('Password')}
                </label>
                <div>
                  <div className='flex'>
                    <span
                      className='inline-flex items-center px-4 text-sm text-gray-900 bg-white border border-e-0 border-gray-300 rounded-s-lg 
                    '>
                      <FontAwesomeIcon icon={faUnlock} color='#B68A35' />
                    </span>
                    <input
                      {...register('password', { required: true })}
                      type='password'
                      id='password'
                      name='password'
                      autoComplete='off'
                      aria-describedby='password_error'
                      className='rounded-none rounded-e-lg bg-white border border-s-0  text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  '
                      placeholder={t('Enteryourpassword')}
                    />
                  </div>
                  {errors.password && (
                    <p
                      id='password_error'
                      className='mt-2 text-xs text-red-600 '>
                      {t('passwordRequired')}
                    </p>
                  )}
                </div>
         
              </div>

              <button
                type='submit'
                className='flex flex-1 gap-3 items-center bg-[#B68A35] rounded-full py-3 justify-center text-white'>
                {loading && <Loader size='sm' color={'white'} />}
                {t('Login')}
              </button>
            </form>
          </div>
       
        </div>
      </div>
    </main>
  );
};

export default Login;
